import React, { useContext } from 'react'
import { AppContext } from '../../../../../contexts'
import { Button, Text } from '../../../../../components'
import { Wand } from '../../../../../components/Svg'
import { TABS } from '../../../../../constants/display'
import styles from './EmptyOverviewPanel.module.scss'

const EmptyOverviewPanel = () => {
  const { setActiveTab } = useContext(AppContext) as any

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.svgWrapper}>
          <Wand />
        </div>
        <Text weight='semibold' size='l' color='white'>
          You have no insights
        </Text>
        <Text color='white'>
          Update your budget so we can crunch the numbers for you.
        </Text>
        <Button
          onClick={() => setActiveTab(TABS.SETTINGS)}
          className={styles.button}
          primary
        >
          <Text element='span' color='white' weight='semibold'>
            Update budget
          </Text>
        </Button>
      </div>
    </div>
  )
}

export default EmptyOverviewPanel
